// extracted by mini-css-extract-plugin
export var colorSquare = "_pd-0";
export var danger = "_pd-5";
export var lightPink = "_pd-8";
export var neutralBlue = "_pd-7";
export var neutralYellow = "_pd-6";
export var normal = "_pd-1";
export var primary = "_pd-2";
export var primaryLight = "_pd-3";
export var solidBlack = "_pd-g";
export var solidGreen = "_pd-b";
export var solidLightBlue = "_pd-d";
export var solidNavy = "_pd-c";
export var solidOrange = "_pd-f";
export var solidPink = "_pd-e";
export var solidRed = "_pd-9";
export var solidYellow = "_pd-a";
export var success = "_pd-4";